import type {
  IPatient,
  IPatientContactInformation,
  PhoneNumberTypeId} from '@app/domain/patient/patient.interface';
import {
  PatientBirthSexId
} from '@app/domain/patient/patient.interface'

export const convertApiPatient = (apiPatient: IApiPatient): IPatient => {
  if (apiPatient.birthSex !== undefined) {
    apiPatient.birthSex = PatientBirthSexId[apiPatient.birthSex]
  }
  return apiPatient as IPatient
}

export interface IApiPatient {
  id: string
  medicalRecordNumber: string
  updatedAt: string
  familyName: string
  givenNames: string
  birthSex?: string
  dateOfBirth?: string
  generalPractitioner?: string
  cohesicId?: number
  contactInformation?: IPatientContactInformation
}

export interface IApiNewPatient {
  medicalRecordNumber: string
  familyName: string
  givenNames: string
  birthSex: string
  dateOfBirth: string
  generalPractitioner: string
}

export interface IApiUpdatePatient {
  medicalRecordNumber: string
  familyName: string
  givenNames: string
  birthSex: string
  dateOfBirth: string
  generalPractitioner: string
  contactInformation?: IPatientContactInformation
}

export type IApiUpdateContactInformation =
  | {
      emailAddress: string
      phoneNumber: string
      phoneNumberType: PhoneNumberTypeId
    }
  | {
      emailAddress: string
    }
  | {
      phoneNumber: string
      phoneNumberType: PhoneNumberTypeId
    }
